import template from './creditFixSolutionButton.template.html';
import templateRefer from './creditFixSolution.template.html';

export default {
  template,
  bindings: {
    contacts: '<',
    owner: '<',
    idTicket: '<',
    isDisabled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $timeout, $mdDialog, dateTimeService, creditFixSolutionService) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.destroyWatch = null;

      ctrl.initialize = () => {
        ctrl.contacts = _.filter(ctrl.contacts || [], (c) => !c?.isCompany);
        ctrl.personContact = _.head(ctrl.contacts);
        ctrl.owner = ctrl.owner || {};
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.isDisabled = ctrl.isDisabled || false;
      };

      ctrl.openDialog = ($event) => {
        $event.stopPropagation();
        $mdDialog.show({
          targetEvent: $event,
          locals: {
            personContact: ctrl.personContact || {},
            owner: ctrl.owner || {},
            idTicket: ctrl.idTicket || ''
          },
          template: templateRefer,
          controllerAs: '$ctrl',
          multiple: true,
          controller(personContact, owner, idTicket) {
            const self = this;
            self.personContact = personContact;
            self.owner = owner;
            self.idTicket = idTicket;
            self.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
            self.organization = $rootScope.CurrentOrganization;
            self.creditFixSolutionDetails = {
              note: '',
              preferredContactDate: 0,
              consent: false
            };
            self.errorMessages = [];
            self.hasError = false;
            self.isSubmitted = false;
            self.isSending = false;
            self.isLoading = false;

            dateTimeService.getSet(
              self,
              self.creditFixSolutionDetails,
              'preferredContactDate',
              'getSetPreferredContactDate'
            );

            self.isDateInThePast = () => {
              if (self.creditFixSolutionDetails.preferredContactDate) {
                const contactDateTime = _.isNumber(
                  self.creditFixSolutionDetails.preferredContactDate
                )
                  ? self.creditFixSolutionDetails.preferredContactDate
                  : dateTimeService.epoch(self.creditFixSolutionDetails.preferredContactDate);
                const isDateInThePast = dateTimeService
                  .getMoment(contactDateTime)
                  .endOf('day')
                  .isBefore(dateTimeService.getMoment(dateTimeService.epoch()));

                if (isDateInThePast) {
                  if (!self.hasError) {
                    self.hasError = true;
                    self.errorMessages.push(
                      'Credit Fix Solution errors:',
                      'The preferred contact date is in the past.'
                    );
                  }
                } else if (!self.isSending) {
                  self.hasError = false;
                  self.errorMessages = [];
                }
                return isDateInThePast;
              }
              return false;
            };

            self.canSend = () => {
              if (
                !self.creditFixSolutionDetails?.consent ||
                !self.creditFixSolutionDetails?.note ||
                !self.creditFixSolutionDetails?.preferredContactDate ||
                self.isDateInThePast()
              ) {
                return false;
              }

              return !self.isDisabled;
            };

            self.confirm = () => {
              self.errorMessages = [];
              self.hasError = false;
              self.isLoading = true;
              self.isSending = false;
              self.isSubmitted = false;
              creditFixSolutionService
                .refer({
                  idTicket: self.idTicket,
                  idContact: self.personContact?.id,
                  creditFixSolutionDetails: self.creditFixSolutionDetails
                })
                .then((result) => {
                  self.isSending = true;
                  self.isLoading = false;
                  if (result?.status) {
                    self.isSubmitted = true;
                    $timeout(() => {
                      $mdDialog.hide();
                    }, 5000);
                  } else {
                    self.hasError = true;
                    if (result?.errors?.length) {
                      const len = result?.errors?.length || 0;
                      for (let e = 0; e < len; e += 1) {
                        const error = result?.errors[e];
                        const message = error?.label
                          ? `${error?.label?.sanitize()} -> ${error?.message || ''}`
                          : error?.message || error || '';
                        self.errorMessages.push(message);
                      }
                    } else {
                      self.errorMessages.push(result?.errorMessage);
                    }
                    self.errorMessages.unshift('Credit Fix Solution errors:');
                  }
                });
            };

            self.cancel = () => {
              $mdDialog.cancel();
            };
          }
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        if (ctrl.destroyWatch) {
          ctrl.destroyWatch();
        }
      };
    }
  }
};
